import { isNotNullOrUndef } from '../../utils/isNotNullOrUndef';
import { listOfAllFacetKeys } from '../configs';
const pathnameOfLoadedPage = window.location.pathname;
const domParser = new DOMParser();
let dataFromLoadedPage = {};
const sectionIDs = [
    'data-alg-config-breadcrumbs-id',
    'data-alg-config-data-id',
    'data-alg-config-filter-id',
    'data-alg-config-template-id'
].reduce((arr, dataKey) => {
    const el = document.querySelector(`[${dataKey}]`);
    const id = el?.getAttribute(dataKey);
    try {
        const jsonStr = el?.textContent;
        if (isNotNullOrUndef(jsonStr)) {
            const parsedData = JSON.parse(jsonStr);
            dataFromLoadedPage = {
                ...dataFromLoadedPage,
                ...parsedData,
                supplementaryData: {
                    ...dataFromLoadedPage.supplementaryData,
                    ...parsedData.supplementaryData
                }
            };
        }
    }
    catch (e) {
        console.log(e);
    }
    isNotNullOrUndef(id) && arr.push(id);
    return arr;
}, []).join(',');
const addKeyToList = (key) => {
    if (!listOfAllFacetKeys.includes(key)) {
        listOfAllFacetKeys.push(key);
    }
};
const addHierarchyKeysToListOfFacets = (objects) => {
    Object.values(objects).forEach(({ facetKey }) => { addKeyToList(facetKey); });
};
export const templateConfigsLoader = async ({ params }) => {
    if (params.handle === undefined || sectionIDs.length < 1)
        return {};
    if (pathnameOfLoadedPage.includes(`/${params.handle}`)) {
        if (dataFromLoadedPage.hierarchyObjects !== undefined) {
            addHierarchyKeysToListOfFacets(dataFromLoadedPage.hierarchyObjects);
        }
        return dataFromLoadedPage;
    }
    const sectionsData = await fetch(`${window.origin}/collections/${params.handle}?sections=${sectionIDs}`)
        .then(async (response) => await response.json());
    const newData = Object.entries(sectionsData).reduce((obj, [key, html]) => {
        try {
            const sectionHtmL = domParser.parseFromString(html, 'text/html');
            const jsonStr = sectionHtmL.querySelector(`#json--${key}`)?.textContent;
            if (isNotNullOrUndef(jsonStr)) {
                const parsedData = JSON.parse(jsonStr);
                return {
                    ...obj,
                    ...parsedData,
                    supplementaryData: {
                        ...obj.supplementaryData,
                        ...parsedData.supplementaryData
                    }
                };
            }
        }
        catch (e) {
            console.log(e);
        }
        return obj;
    }, {});
    if (newData.hierarchyObjects !== undefined) {
        addHierarchyKeysToListOfFacets(newData.hierarchyObjects);
    }
    return newData;
};
